import { useCallback } from 'react';
import type { AppRunDetail, ViewSnapshot } from '@api/apps';
import { useViewSnapshot, type ViewSnapshotOptions } from '../viewSnapshot';

/** What the user is looking at goes with a turn, once there is a version of theirs to look at. */
export const useRunCaptureView = (surface: ViewSnapshotOptions['surface'], appKey: string | undefined, run: AppRunDetail | null) => {
  const { rootRef, capture } = useViewSnapshot({ surface, appKey });
  const captureView = useCallback(async (): Promise<ViewSnapshot | undefined> => {
    if (!run || run.readOnly || run.results.length === 0) return undefined;
    return (await capture()) ?? undefined;
  }, [capture, run]);
  return { rootRef, capture, captureView };
};
